const baseCityUrl = data => {
  if (!data || !data.serviceTypeInfo) return undefined;

  return `/service-type/${data.serviceTypeInfo.baseCityServiceTypeId}`;
};

export default baseCityUrl;
